// Generated by ts-to-zod
import { z } from "zod";

export const loginRequestSchema = z.object({
    phone: z.string(),
    password: z.string()
});

export const verifyPhoneNumberRequestSchema = z.object({
    requestId: z.number(),
    phone: z.string(),
    code: z.string()
});

export const createMeditationRetreatRequestSchema = z.object({
    title: z.string(),
    levelId: z.number(),
    fromDate: z.string(),
    toDate: z.string(),
    maxYogiLimit: z.number()
});

export const createContactRequestSchema = z.object({
    title: z.string(),
    driverName: z.string(),
    phone: z.string(),
    pickUpTime: z.string(),
    pickUpDate: z.string(),
    address: z.string()
});

export const addNewMeditatorRequestSchema = z.object({
    bookNo: z.string().optional(),
    nrcNo: z.string().nullable(),
    name: z.string(),
    phone: z.string(),
    dob: z.string(),
    levelId: z.number(),
    address: z.string(),
    note: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    fatherName: z.string()
});

export const manualRegisterMeditatorRequestSchema = z.object({
    userId: z.number(),
    meditationEventId: z.string(),
    action: z.union([z.literal("decline"), z.literal("register")])
});

export const createPaymentRequestSchema = z.object({
    accName: z.string(),
    accNo: z.string(),
    paymentType: z.string(),
    published: z.boolean().default(false)
});

export const sendNotificationRequestSchema = z.object({
    title: z.string(),
    body: z.string(),
    type: z.enum(['IN_APP', 'NOTICE'])
});

export const createAdminAccountRequestSchema = z.object({
    phone: z.string(),
    password: z.string(),
    name: z.string()
});
